import { DiContainerInjectFn } from '@@/di/ts';
import { ClientStorageService } from './services/client-storage.service';
import { LoggerService } from '@@/common/services/logger.service';

export default ((container) => {
  container.bind(ClientStorageService).to(ClientStorageService).inSingletonScope();
  container.bind(LoggerService).to(LoggerService).inSingletonScope();
}) as DiContainerInjectFn;
